<template>
<div class="chapter">
<div class="inner_page">
<p class="titlepage" id="tp"><a id="page_iii">A Voice Crying in the Wilderness</a></p><a id="page_iii">
<p class="titlepage1">Edward Abbey</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?3ae3ee4f